import { GoogleMap, GoogleMapProps } from "@react-google-maps/api";
import { forwardRef } from "react";
import { setRef } from "./helpers";
import { useMapContext } from "~/providers/MapContextProvider";
import { useBreakpointValue } from "@chakra-ui/react";

type Props = GoogleMapProps & {};

export const BaseMap = forwardRef<google.maps.Map, Props>(
  ({ onLoad, options, ...props }, ref) => {
    const { mapSelected } = useMapContext();
    const showControls = useBreakpointValue({ base: mapSelected, lg: true });
    return (
      <GoogleMap
        zoom={16}
        mapContainerStyle={{
          width: "100%",
          height: "100%",
        }}
        options={{
          fullscreenControl: showControls,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.RIGHT_BOTTOM,
          },
          zoomControl: showControls,
          streetViewControl: false,
          mapTypeControl: false,
          mapId: "581411231e02f215",
          ...options,
        }}
        onLoad={(map) => {
          setRef(ref, map);
          onLoad && onLoad(map);
        }}
        {...props}
      />
    );
  }
);

BaseMap.displayName = "BaseMap";
